import { IStation } from '@models'
import Image from 'next/image'
import React from 'react'
import styles from './logo.module.scss'

// Only `id` is read, so the prop is narrowed to it — a full IStation still
// satisfies this, but a slim client-side ref does too.
export default function Logo({station, lazy, alt}: {station: Pick<IStation, 'id' | 'name'>, lazy?: boolean, alt?: string}) {
    // Eager loading is opt-in: only `lazy={false}` gets priority. Everything else —
    // list rows, grids, the flat station index — stays lazy, so a 90-row page
    // doesn't queue 90 priority images against the LCP.
    const eager = lazy === false
    return (
        <div className={styles.logo}>
            <Image
                priority={eager}
                loading={eager? undefined: 'lazy'}
                src={`/images/stations/${station.id}.webp`}
                className={`${styles.logo} animated`}
                // Empty by default: in list rows the adjacent station name is the
                // link text, so a non-empty alt just duplicates the anchor. Pass
                // `alt` explicitly where the logo stands alone.
                alt={alt ?? station.name}
                width={470}
                height={300}
            />
        </div>
    )
}